import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import AddLabEntery from "./addLabEntery"

const AddLabEnteryContainer = () => {

 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
           <AddLabEntery />
        </>
      </div>
    </div>
  )
}

export default AddLabEnteryContainer